import { ProduktLandingPage } from "@/features/hca-public";
import { PublicShellWithDiagnoza } from "@/route-helpers/public-shell-with-diagnoza";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/seminare/$slug")({
  component: SeminareRoute,
});

function SeminareRoute() {
  const { slug } = Route.useParams();
  return (
    <PublicShellWithDiagnoza>
      <ProduktLandingPage slug={slug} />
    </PublicShellWithDiagnoza>
  );
}
